var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.725,
    height: 14.726,
    viewBox: "0 0 14.725 14.726",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    d: "M4161.4,606.637a7.363,7.363,0,1,0,7.362,7.363A7.363,7.363,0,0,0,4161.4,606.637Zm1.977,4.295h-3.954a2.1,2.1,0,1,1,3.954,0Zm.49,1.227a5.95,5.95,0,0,1,0,3.682h-4.936a5.95,5.95,0,0,1,0-3.682Zm-4.063-4.076a12.059,12.059,0,0,0-1.733,2.849H4156.1A6.155,6.155,0,0,1,4159.806,608.083Zm-4.54,5.917a6.151,6.151,0,0,1,.283-1.841h2.11a7.036,7.036,0,0,0,0,3.682h-2.11A6.151,6.151,0,0,1,4155.266,614Zm.83,3.068h1.977a12.059,12.059,0,0,0,1.733,2.849A6.155,6.155,0,0,1,4156.1,617.068Zm3.329,0h3.954a2.1,2.1,0,1,1-3.954,0Zm3.575,2.849a12.084,12.084,0,0,0,1.731-2.849h1.976a6.157,6.157,0,0,1-3.707,2.849Zm4.537-5.917a6.12,6.12,0,0,1-.283,1.841h-2.11a7.009,7.009,0,0,0,0-3.682h2.109A6.121,6.121,0,0,1,4167.537,614Zm-2.806-3.068a12.084,12.084,0,0,0-1.731-2.849,6.157,6.157,0,0,1,3.707,2.849Z",
    transform: "translate(-4154.039 -606.637)",
    fill: "#98a9b8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.eace523f3440102e7cdf007d7527eec4.svg";
export { ForwardRef as ReactComponent };